export const userInputs = [
    {
        id: 1,
        label: "Username",
        type: "text",
        placeholder: "Username",
    },
    {
        id: 2,
        label: "Full Name",
        type: "text",
        placeholder: "Full name",
    },
    {
        id: 3,
        label: "Email",
        type: "email",
        placeholder: "Email",
    },
    {
        id: 4,
        label: "Password",
        type: "password",
        placeholder: "Enter password",
    },
    {
        id: 5,
        label: "Phone",
        type: "text",
        placeholder: "Phone number",
    },
    {
        id: 6,
        label: "Address",
        type: "text",
        placeholder: "Enter Address",
    },
    {
        id: 7,
        label: "Country",
        type: "text",
        placeholder: "Enter Country",
    },
];

export const productInputs = [
    {
        id: 1,
        label: "Title",
        type: "text",
        placeholder: "Apple Macbook Pro",
    },
    {
        id: 2,
        label: "Description",
        type: "text",
        placeholder: "Description",
    },
    {
        id: 3,
        label: "Category",
        type: "text",
        placeholder: "Computers",
    },
    {
        id: 4,
        label: "Price",
        type: "text",
        placeholder: "100",
    },
    {
        id: 5,
        label: "Stock",
        type: "text",
        placeholder: "in stock",
    },
];

export const hotelsInputs = [
    {
        id: 1,
        label: "Name",
        type: "text",
        placeholder: "Hotel Name",
    },
    {
        id: 2,
        label: "Property Type",
        type: "text",
        placeholder: "Property Type",
    },
    {
        id: 3,
        label: "City",
        type: "text",
        placeholder: "City",
    },
    {
        id: 4,
        label: "Address",
        type: "text",
        placeholder: "Address",
    },
    {
        id: 5,
        label: "Distance From City Center",
        type: "text",
        placeholder: "Distance From City Center",
    },
    {
        id: 6,
        label: "Description",
        type: "text",
        placeholder: "Description",
    },
    {
        id: 7,
        label: "Rating",
        type: "text",
        placeholder: "Rating",
    },
    {
        id: 8,
        label: "Price",
        type: "text",
        placeholder: "Chipest Price",
    },
];
